import React from "react";
import { Container, Grid } from "@mui/material";
import Modal from "@mui/material/Modal";
import "./warningModal.scss";
import warning from "../../../assets/authentication-imgs/warning2.svg";
import WarningModal from "./warningModal";

interface IMODAL {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  openModal: boolean;
}

const IncorrectAttempts: React.FC<IMODAL> = (props) => {
  return (
    <div className="login-modal">
      <WarningModal
        setOpenModal={props.setOpenModal}
        openModal={props.openModal}
        image={warning}
        text={"Your account been locked due to several incorrect attemps"}
      />
    </div>
  );
};

export default IncorrectAttempts;
